import axios from 'axios'
import { API_BASE_URL } from '@/shared/lib/constants'
import type {
  CampaniaPublicaInfo,
  FormularioPublicoData,
  SuccessResponse,
} from '../types'

// API pública sin JWT - usa axios directamente
const publicClient = axios.create({
  baseURL: `${API_BASE_URL}/muestras-medicas/publico`,
})

export async function getInfoCampaniaPublica(uuid: string): Promise<CampaniaPublicaInfo> {
  const { data } = await publicClient.get(`/muestras/${uuid}/info/`)
  return data
}

export async function getFormularioPublico(uuid: string): Promise<FormularioPublicoData> {
  const { data } = await publicClient.get(`/muestras/${uuid}/formulario/`)
  return data
}

export async function enviarSolicitudEstandar(
  uuid: string,
  payload: {
    nombre: string
    apellido: string
    telefono: string
    correo: string
    provincia: string
    ciudad: string
    aceptar_terminos: boolean
    autorizar_envio_mm: boolean
  },
): Promise<SuccessResponse> {
  const { data } = await publicClient.post(`/muestras/${uuid}/enviar/`, payload)
  return data
}

export async function enviarPasoFormulario(
  uuid: string,
  payload: { paso_numero: number; respuestas: Record<string, unknown> },
): Promise<SuccessResponse> {
  const { data } = await publicClient.post(`/muestras/${uuid}/enviar-paso/`, payload)
  return data
}

export async function getInfoEncuestaPublica(uuid: string) {
  const { data } = await publicClient.get(`/encuesta/${uuid}/info/`)
  return data
}

export async function getFormularioEncuestaPublica(uuid: string) {
  const { data } = await publicClient.get(`/encuesta/${uuid}/formulario/`)
  return data
}

export async function enviarEncuestaPublica(
  uuid: string,
  payload: { paso_numero: number; respuestas: Record<string, unknown> },
): Promise<SuccessResponse> {
  const { data } = await publicClient.post(`/encuesta/${uuid}/enviar/`, payload)
  return data
}
